import { render, staticRenderFns } from "./VirtualExamine.vue?vue&type=template&id=b0af4bea&scoped=true"
import script from "./VirtualExamine.vue?vue&type=script&lang=js"
export * from "./VirtualExamine.vue?vue&type=script&lang=js"
import style0 from "./VirtualExamine.vue?vue&type=style&index=0&id=b0af4bea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0af4bea",
  null
  
)

export default component.exports